let tlsInstallPrompt = null;

const tlsPopup = document.getElementById("tls-install-popup");
const tlsInstallButton = document.getElementById("tls-install-button");
const tlsLater = document.querySelector(".tls-later");
const tlsClose = document.querySelector(".tls-close");


// Detect iPhone / iPad
function isIOS(){

    return /iphone|ipad|ipod/i.test(
        window.navigator.userAgent
    );

}


// Detect if already installed
function isStandalone(){

    return (
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true
    );

}


// Check if popup should appear
function shouldShowTLSInstall(){

    let dismissed = localStorage.getItem(
        "tls-install-dismissed"
    );


    if(!dismissed){
        return true;
    }


    return Date.now() > Number(dismissed);

}



// Show popup
function showTLSInstallPopup(){

    if(
        isStandalone() ||
        !shouldShowTLSInstall()
    ){
        return;
    }


    setTimeout(()=>{

        tlsPopup.style.display="flex";

    },3000);

}




// Android install event
window.addEventListener(
"beforeinstallprompt",
(e)=>{


    e.preventDefault();


    tlsInstallPrompt = e;


    if(
        !isIOS() &&
        window.innerWidth <= 768
    ){

        showTLSInstallPopup();

    }


});





// iPhone / iPad
window.addEventListener(
"load",
()=>{


    if(isIOS()){


        showTLSInstallPopup();


        document.querySelector(
        ".tls-ios-instructions"
        ).style.display="block";


        tlsInstallButton.style.display="none";


    }


});





// Android install button
tlsInstallButton.addEventListener(
"click",
async()=>{


    if(!tlsInstallPrompt){
        return;
    }


    tlsPopup.style.display="none";


    tlsInstallPrompt.prompt();


    await tlsInstallPrompt.userChoice;


    tlsInstallPrompt=null;


});





function closeTLSPopup(){

    tlsPopup.style.display="none";


    localStorage.setItem(
        "tls-install-dismissed",
        Date.now() +
        (30*24*60*60*1000)
    );

}



tlsClose.onclick = closeTLSPopup;

tlsLater.onclick = closeTLSPopup;



window.addEventListener(
"appinstalled",
()=>{


    localStorage.setItem(
        "tls-installed",
        "true"
    );


    tlsPopup.style.display="none";


});